export const DATA_TEST_IDS = {
  HOME: {
    HERO: 'home-hero',
  },
  EMPLOYEE_STORIES: {
    HERO: 'employee-stories-hero',
  },
}
